// @flow
import React from 'react'
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'direct-bill',
  icon: [
    52,
    34,
    null,
    null,
    null,
    <path
      key="1"
      fill="#3C84C5"
      d="M13.79 19.2c0-.4-.11-.72-.34-.96-.22-.24-.6-.46-1.13-.66-.53-.2-.99-.4-1.38-.6a4.39 4.39 0 0 1-.99-.67 2.74 2.74 0 0 1-.64-.9 3.05 3.05 0 0 1-.23-1.25c0-.82.26-1.5.79-2.03a3.34 3.34 0 0 1 2.1-.92V9.64h1.17v1.6c.87.11 1.54.48 2.03 1.07.49.6.73 1.38.73 2.33H13.8c0-.59-.12-1.03-.37-1.32a1.2 1.2 0 0 0-.97-.43c-.4 0-.7.11-.93.34a1.3 1.3 0 0 0-.33.94c0 .37.11.67.33.9.21.22.61.45 1.2.68a13.3 13.3 0 0 1 1.43.67c.38.2.7.44.95.7a2.73 2.73 0 0 1 .8 2.06c0 .83-.26 1.5-.77 2.02a3.4 3.4 0 0 1-2.14.92v1.45h-1.17v-1.45c-1-.1-1.77-.46-2.32-1.06-.55-.6-.83-1.4-.83-2.4h2.12c0 .57.14 1.02.41 1.33.28.31.68.46 1.2.46.42 0 .76-.1 1.01-.34.25-.22.38-.53.38-.92zM4 2a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h44a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm20 10h14v2H24v-2zm0 6h22v2H24v-2zm0 6h18v2H24v-2z"
    />,
  ],
})
